<template>
  <div class="contents">
    <section class="main">
      <oshirase-summary></oshirase-summary>
      <dakoku-panel v-if="APP_MODE.KINTAI === Config.APP_MODE" ></dakoku-panel>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DakokuPanel from "@/components/dakoku/DakokuPanel.vue";
import OshiraseSummary from "@/components/oshirase/Summary.vue";
import { useAuthStore } from "@/store/auth";
import { APP_MODE } from "@/const/Constants";
import Config from "@/const/Config";
export default defineComponent({
  beforeRouteEnter(to, from, next){
    const authStore = useAuthStore();
    if(authStore.role?.is_syagai){
      // TODO: ここにマイタスクページのnameを指定する（マイタスクページが完成次第）
      next()
      return
    }
    next()
  },
  setup() {
    return{
      APP_MODE,
      Config
    }
  },
  components: {
    "dakoku-panel": DakokuPanel,
    "oshirase-summary": OshiraseSummary,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/pages/home.scss';
</style>
